<template>
    <section class="section-intro">
        <div class="container space-y-8 lg:pb-16">
            <article>
                <motion.div
                    v-if="props.images"
                    class="intro-images"
                    :in-view-options="motionInViewOptions"
                    :initial="motionInitial"
                    :transition="{...motionTransitionBase, delay: mascotDelay}"
                    :while-in-view="motionWhileInView"
                >
                    <HexagonImage
                        v-for="(image, index) in props.images"
                        :key="index"
                        :img-src="image"
                        :style="(props.images.length === 1) ? 'width: 85%;left: 15%;' : ''"
                    />

                    <div
                        v-if="props.images.length > 1"
                        class="images-mukki"
                    >
                        <MotionNuxtImg
                            src="Mukki_Front2.png"
                            alt="Maskottchen"
                            :in-view-options="motionInViewOptions"
                            :initial="motionInitial"
                            :transition="{...motionTransitionBase, delay: mascotDelay}"
                            :while-in-view="motionWhileInView"
                        />
                    </div>
                </motion.div>

                <div
                    v-if="props.title || props.teaser || props.text"
                    class="intro-text space-y-4 rounded-lg"
                >
                    <h1
                        v-if="props.title"
                        class="title"
                        :class="String(route.name) === 'sustainability' ? 'text-sustainability!' : ''"
                    >
                        {{ props.title }}
                    </h1>
                    <p
                        v-if="props.teaser"
                        class="article-teaser"
                    >
                        {{ props.teaser }}
                    </p>
                    <div
                        v-if="props.text"
                        v-html="props.text"
                    />
                  <slot/>
                  <UButton
                      v-if="props.cta"
                      v-bind="props.cta"
                  />
                </div>
            </article>
        </div>
    </section>
</template>

<script setup lang="ts">
import type {RouteLocationRaw} from 'vue-router';
import {motion} from 'motion-v';
import type {ButtonProps} from '@nuxt/ui'

const NuxtImg = resolveComponent('NuxtImg');
const MotionNuxtImg = motion.create(NuxtImg);

const motionInitial = {
    opacity: 0,
    y: 50,
};
const motionWhileInView = {
    opacity: 1,
    y: 0,
};
const motionInViewOptions = {once: true};
const motionTransitionBase = {
    duration: 0.8,
    ease: 'easeOut',
};
const titleDelay = 0.25;
const descriptionDelay = 0.35;
const bodyDelay = 0.45;
const mascotDelay = 0.3;
const hexagonDelayStep = 0.15;

interface Props {
    images?: string[];
    title?: string;
    teaser?: string;
    text?: string;
  cta?: ButtonProps;
}

const props = defineProps<Props>();

const route = useRoute();
</script>

<style scoped>
.section-intro {
    @apply min-h-[600px];

    article:before {
        content: '';
        display: table;
    }

    article {
        & > .intro-images {
            position: relative;
            height: 0;
            padding-bottom: 110%;
            width: 90%;
            margin: 0 auto;

            @media (min-width: 992px) {
                max-width: 45%;
                height: auto !important;
                padding-bottom: 0 !important;
                margin: 0;
            }

            & > div {
                position: absolute;
                top: 0;

                &:nth-child(1) {
                    width: 52%;
                    left: 0;
                }

                &:nth-child(2) {
                    width: 46%;
                    transform: translate(0, 9%);
                    left: 54%;
                }

                &:nth-child(3) {
                    width: 44%;
                    transform: translate(0, 92%);
                    left: 31.5%;
                }

                &.images-mukki {
                    left: -5%;
                    width: 50%;
                    transform: translate(0, 55%);
                }
            }
        }

        & > .intro-text {
            background: var(--color-neutral-100) !important /* neutral-100 cream brand bg */;
          position: relative;
            @media (min-width: 992px) {
                padding: 1.5rem;
                margin: 200px 0 0 40%;
            }
        }
    }
}
</style>
